var _a;
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./costCenter.constants";
export var getPaged = (_a = generateApi(GENERATOR_PARAMS), _a.getPaged), getDetail = _a.getDetail, getCount = _a.getCount, getInfiniteLoad = _a.getInfiniteLoad, update = _a.update, create = _a.create, remove = _a.remove;
